import { useEffect } from 'react';
import { Modal, Drawer, DrawerProps, ModalProps } from 'antd';
import {
  mobileWidth,
  useIsMobile,
} from '@keyslabor/shared/hooks/useBreakPoint';
import {
  Body,
  Close,
  Footer as FooterBase,
  GlobalModalStyle,
  Ok,
  Success,
} from './ModalConfirm.ui';
import { CloseProps, ModalConfirmProps, OkProps } from './types';
import useAsyncCb from './useAsyncCbOk';
import useConfirmClose from './useConfirmClose';
import { px } from '@/utils';

export default function ModalConfirm(props: ModalConfirmProps) {
  const {
    children,
    FooterElement,
    raw,
    show,
    success,
    rootBoxProps,
    title,
    titleSuccess,
    drawer,
    footer,
    footerProps,
    loading,
    textSuccessOk,
    onClose,
    onSuccessOk,
    setSuccess,
    textOk = 'Yes',
    textClose = 'No',
    isFormValid,
    drawerHeight,
    customDesktopWidth,
    okProps: okPropsBase,
    closeProps: closePropsBase,
    bodyHeight,
    centerBodyElements,
    ...restProps
  } = props;

  const isDrawer = !success && drawer;

  const BaseComp = isDrawer ? Drawer : Modal;

  const isMobile = useIsMobile();

  const handleOk = useAsyncCb({
    ...props,
    successMessage: titleSuccess,
    onSuccessOk,
  });

  const handleClose = useConfirmClose(props);

  const baseCompProps: DrawerProps | ModalProps = {
    placement: 'bottom',
    onClose: handleClose,
    onCancel: handleClose,
  };

  const okProps: OkProps = {
    onClose: handleClose,
    onSuccessOk,
    setSuccess,
    success,
    textSuccessOk,
    onOk: handleOk,
    textOk,
    loading,
    ...okPropsBase,
  };

  const closeProps: CloseProps = {
    onClose: handleClose,
    success,
    textClose,
    ...closePropsBase,
  };

  /*useEffect(() => {
    if (success) {
      toast.success(titleSuccess);
      closeProps.onClose?.();
    }
  }, [success]);
*/

  const Footer = success ? FooterBase : (FooterElement ?? FooterBase);

  return (
    <>
      {show && (
        // @ts-expect-error TODO: fix types here
        <GlobalModalStyle
          drawerHeight={drawerHeight}
          success={success}
          isMobile={isMobile}
          {...restProps}
        />
      )}

      <BaseComp
        // @ts-expect-error TODO: fix types here
        width={isMobile ? px(mobileWidth) : 'max-content'}
        open={show}
        destroyOnClose={true}
        centered
        rootStyle={{ padding: 0 }}
        footer={null}
        closable={false}
        closeIcon={<> </>}
        {...(baseCompProps as object)}
        {...restProps}
      >
        {/* <Spinner loading={loading} /> */}
        {raw ? (
          children
        ) : (
          <Body
            full={restProps.full}
            drawer={isDrawer}
            isMobile={isMobile}
            title={title}
            rootBoxProps={rootBoxProps}
            customDesktopWidth={customDesktopWidth}
            bodyHeight={bodyHeight}
            centerBodyElements={centerBodyElements}
            footer={
              footer === null
                ? null
                : (footer ?? (
                    <Footer
                      okProps={okProps}
                      isFormValid={isFormValid}
                      okRender={<Ok {...okProps} />}
                      closeProps={closeProps}
                      closeRender={<Close {...closeProps} />}
                      isMobile={isMobile}
                      vertical={isDrawer}
                      success={success}
                      {...restProps}
                      {...footerProps}
                      buttonProps={{
                        ...footerProps?.buttonProps,
                        ...(isDrawer && { kind: 'normal' }),
                      }}
                    />
                  ))
            }
          >
            {success ? <Success titleSuccess={titleSuccess} /> : children}
          </Body>
        )}
      </BaseComp>
    </>
  );
}
